import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Button, Skeleton, Modal, Divider } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import InformativeForm from '@/components/Informative/form';
import { useHistory, useRouteMatch } from 'react-router-dom';

import React, { useEffect } from 'react';
import { InformativeFormValues } from '@/core/domain/notification/Informative/Informative.types';
import {
  useDeleteInformative,
  useInformative,
} from '@/core/domain/notification/Informative/Informative.hooks';
import moment from 'moment';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function InformativeDetailsPage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();
  const { informativeId } = useRouteMatch<{ informativeId: string }>().params;
  const [form] = Form.useForm<InformativeFormValues>();

  const { data, isFetching, dataUpdatedAt } = useInformative(
    Number(informativeId),
  );

  const removeInformativeMutation = useDeleteInformative();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        dataInformation: moment(data.informationDate),
      });
    }
  }, [dataUpdatedAt]);

  const handleRemoveClick = () => {
    Modal.confirm({
      title: intl.formatMessage({
        id: 'informative.notifications.remove.confirm.title',
      }),
      content: `${intl.formatMessage({
        id: 'informative.notifications.remove.confirm.content',
      })}`,
      okText: intl.formatMessage({
        id: 'commons.entity.remove',
      }),
      onOk: async () => {
        await removeInformativeMutation.mutateAsync(Number(informativeId));

        history.push('/app/informative');
      },
      okType: 'danger',
    });
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <Button
          danger
          onClick={handleRemoveClick}
          disabled={
            !hasPermissions(
              [
                Authorities.DEFAULT_INFORMATIVE_EDIT,
                Authorities.MESSAGE_UPDATE,
              ],
              true,
            )
          }
        >
          <FormattedMessage id="commons.form.button.remove" />
        </Button>
      }
    >
      <Skeleton loading={isFetching}>
        <InformativeForm
          form={form}
          isEdit={!!data?.id}
          usersId={data?.usersID}
        />

        <Divider />

        <SpaceForButton>
          <ButtonBack path="/app/informative" />
        </SpaceForButton>
      </Skeleton>
    </TabContentWrapper>
  );
}

export default InformativeDetailsPage;
